module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Light-c9258c805fb977bc9969d10e6636ef13.woff";